// import React, { useEffect, useState } from 'react';
// import './../../css/table.css';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import Spinner from 'react-bootstrap/Spinner';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useFormik } from 'formik';
// import * as yup from 'yup';
// import withReactContent from 'sweetalert2-react-content';
// import InputCustom from '../Auth/InputCustom';
// import styles from '../Auth/input.module.css';
// import { useParams } from 'react-router-dom';
// import TextAreaCustom from '../Auth/TextAreaCustom';

// const MySwal = withReactContent(Swal);

// const EditOpportunity = () => {
//   const [countries, setCountries] = useState([]);
//   const [initialValues, setInitialValues] = useState([]);
//   const { id } = useParams();

//   useEffect(() => {
//     getCountries();
//     getJobData();
//   }, []);

//   const getJobData = () => {
//     axios
//       .get(`https://arianaapp.arianaapply.com/api/V1/get-job-opportunity/${id}`)
//       .then((res) => {
//         console.log(res);
//         setInitialValues(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   const getCountries = () => {
//     axios
//       .get(`https://arianaapp.arianaapply.com/api/V1/show-country-filter`)
//       .then((res) => {
//         console.log(res);
//         setCountries(res.data);
//       })
//       .catch((err) => {
//         console.log(err.response);
//       });
//   };
//   const validationSchema = yup.object({
//     title: yup.string().required('وارد کردن عنوان الزامیست'),
//     title_fa: yup.string().required('وارد کردن عنوان به فارسی الزامیست'),
//     city: yup.string().required('وارد کردن شهر الزامیست'),
//     city_fa: yup.string().required('وارد کردن شهر به فارسی الزامیست'),
//     country: yup.string().required('وارد کردن کشور الزامیست'),
//     company: yup.string().required('وارد کردن شرکت الزامیست'),
//     apply_link: yup.string().required('وارد کردن لینک اپلای الزامیست'),
//     responsibility: yup.string().required('وارد کردن مسئولیت الزامیست'),
//     document: yup.string().required('وارد کردن مدارک الزامیست'),
//     type: yup.string().required('وارد کردن دسته بندی الزامیست'),
//     subject: yup.string().required('وارد کردن موضوع الزامیست'),
//     salary: yup.string().required('وارد کردن حقوق الزامیست'),
//     deadline: yup.string().required('وارد کردن ددلاین الزامیست'),
//   });

//   const onSubmit = (state) => {
//     axios
//       .post('https://arianaapp.arianaapply.com/panel/edit-job-opportunity', {
//         title: state.title,
//         title_fa: state.title_fa,
//         city: state.city,
//         city_fa: state.city_fa,
//         country: state.country,
//         company: state.company,
//         apply_link: state.apply_link,
//         responsibility: state.responsibility,
//         document: state.document,
//         type: state.type,
//         img: '',
//         subject: state.subject,
//         salary: state.salary,
//         deadline: state.deadline,
//         id: id,
//       })
//       .then((response) => {
//         console.log(response);
//         MySwal.fire({
//           title: 'با موفقیت ثبت شد',
//           icon: 'success',
//         }).then((result) => {
//           if (result) {
//             window.location.reload();
//           }
//         });
//       })
//       .catch((err) => {
//         console.log(err);
//         MySwal.fire({
//           title: 'دوباره امتحان کنید',
//           icon: 'error',
//         });
//       });
//   };

//   const formik = useFormik({
//     initialValues: initialValues,
//     onSubmit,
//     validationSchema,
//     validateOnMount: true,
//     enableReinitialize: true,
//   });
//   console.log('values', initialValues);
//   return (
//     <div className='index'>
//       {countries.length > 0 ? (
//         <form onSubmit={formik.handleSubmit}>
//           <h2>ویرایش موقعیت شغلی</h2>
//           <InputCustom
//             name='title'
//             type='text'
//             label='عنوان شغلی...'
//             formikHandler={formik.getFieldProps('title')}
//             formikErrors={formik.errors.title && formik.touched.title}
//             formikErrorsName={formik.errors.title}
//           />
//           <InputCustom
//             name='title_fa'
//             type='text'
//             label=' عنوان شغلی به فارسی...'
//             formikHandler={formik.getFieldProps('title_fa')}
//             formikErrors={formik.errors.title_fa && formik.touched.title_fa}
//             formikErrorsName={formik.errors.title_fa}
//           />
//           <InputCustom
//             name='city'
//             type='text'
//             label='شهر...'
//             formikHandler={formik.getFieldProps('city')}
//             formikErrors={formik.errors.city && formik.touched.city}
//             formikErrorsName={formik.errors.city}
//           />
//           <InputCustom
//             name='city_fa'
//             type='text'
//             label='شهر به فارسی...'
//             formikHandler={formik.getFieldProps('city_fa')}
//             formikErrors={formik.errors.city_fa && formik.touched.city_fa}
//             formikErrorsName={formik.errors.city_fa}
//           />
//           <InputCustom
//             name='subject'
//             type='text'
//             label='موضوع...'
//             formikHandler={formik.getFieldProps('subject')}
//             formikErrors={formik.errors.subject && formik.touched.subject}
//             formikErrorsName={formik.errors.subject}
//           />
//           <InputCustom
//             name='salary'
//             type='text'
//             label='حقوق دریافتی...'
//             formikHandler={formik.getFieldProps('salary')}
//             formikErrors={formik.errors.salary && formik.touched.salary}
//             formikErrorsName={formik.errors.salary}
//           />
//           <div className={styles.inputWrap}>
//             <label className={styles.label}>کشور...</label>
//             <select
//               name='country'
//               className={
//                 formik.errors.country && formik.touched.country
//                   ? styles.inputError
//                   : styles.input
//               }
//               {...formik.getFieldProps('country')}>
//               <option value=''>انتخاب کنید...</option>
//               {countries?.map((c) => (
//                 <option key={c.country} value={c.country}>
//                   {c.country}
//                 </option>
//               ))}
//             </select>
//             {formik.errors.country && formik.touched.country && (
//               <p className={styles.errorText}>{formik.errors.country}</p>
//             )}
//           </div>
//           <InputCustom
//             name='company'
//             type='text'
//             label='شرکت...'
//             formikHandler={formik.getFieldProps('company')}
//             formikErrors={formik.errors.company && formik.touched.company}
//             formikErrorsName={formik.errors.company}
//           />
//           <InputCustom
//             name='apply_link'
//             type='text'
//             label='لینک اپلای...'
//             formikHandler={formik.getFieldProps('apply_link')}
//             formikErrors={formik.errors.apply_link && formik.touched.apply_link}
//             formikErrorsName={formik.errors.apply_link}
//           />
//           <InputCustom
//             name='deadline'
//             type='date'
//             label='ددلاین..'
//             formikHandler={formik.getFieldProps('deadline')}
//             formikErrors={formik.errors.deadline && formik.touched.deadline}
//             formikErrorsName={formik.errors.deadline}
//           />
//           <div className={styles.inputWrap}>
//             <label className={styles.label}>دسته بندی....</label>
//             <select
//               name='type'
//               className={
//                 formik.errors.type && formik.touched.type
//                   ? styles.inputError
//                   : styles.input
//               }
//               {...formik.getFieldProps('type')}>
//               <option value=''>انتخاب کنید...</option>
//               <option value='accounting'>حسابداری</option>
//               <option value='medical'>پزشکی</option>
//               <option value='engineering'>مهندسی</option>
//               <option value='teacher'>معلم</option>
//               <option value='consultant'>مشاور</option>
//               <option value='marketing'>بازاریابی و فروش</option>
//               <option value='art'>هنر</option>
//               <option value='law'>حقوق</option>
//               <option value='management'>مدیریت</option>
//             </select>
//             {formik.errors.type && formik.touched.type && (
//               <p className={styles.errorText}>{formik.errors.type}</p>
//             )}
//           </div>
//           <TextAreaCustom
//             name='responsibility'
//             type='text'
//             label='مسئولیت ها..'
//             formikHandler={formik.getFieldProps('responsibility')}
//             formikErrors={
//               formik.errors.responsibility && formik.touched.responsibility
//             }
//             formikErrorsName={formik.errors.responsibility}
//           />
//           <TextAreaCustom
//             name='document'
//             type='text'
//             label='مدارک..'
//             formikHandler={formik.getFieldProps('document')}
//             formikErrors={formik.errors.document && formik.touched.document}
//             formikErrorsName={formik.errors.document}
//           />

//           <div className='inputBox'>
//             <button
//               type='submit'
//               className={!formik.isValid ? 'btn-gray' : 'btn-success'}
//               disabled={!formik.isValid}>
//               ثبت
//             </button>
//           </div>
//         </form>
//       ) : (
//         <Spinner animation='border' variant='primary' />
//       )}
//     </div>
//   );
// };

// export default EditOpportunity;



import React, { useEffect, useState } from 'react';
import './../../css/table.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import Spinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useFormik } from 'formik';
import * as yup from 'yup';
import withReactContent from 'sweetalert2-react-content';
import InputCustom from '../Auth/InputCustom';
import styles from '../Auth/input.module.css';
import { useParams } from 'react-router-dom';
import TextAreaCustom from '../Auth/TextAreaCustom';

const MySwal = withReactContent(Swal);

const EditOpportunity = () => {
  const [countries, setCountries] = useState([]);
  const [categories, setCategories] = useState([]); // لیست دسته‌بندی‌ها
  const [initialValues, setInitialValues] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [countriesRes, categoriesRes, jobRes] = await Promise.all([
          // axios.get('https://arianaapp.arianaapply.com/api/V1/show-country-filter'),
          axios.get('https://arianaapp.arianaapply.com/panel/get-country'),
          axios.get('https://arianaapp.arianaapply.com/panel/show-cat-job-opportunity-all'),
          axios.get(`https://arianaapp.arianaapply.com/api/V1/get-job-opportunity/${id}`),
        ]);

        // setCountries(countriesRes.data || []);
        console.log('Countries RAW:', countriesRes.data);
        console.log('Job country value:', jobRes.data?.country);

        console.log('Countries RAW:', countriesRes.data);

        const countriesData = countriesRes.data;
        if (Array.isArray(countriesData)) {
          setCountries(countriesData);
        } else if (Array.isArray(countriesData?.data)) {
          setCountries(countriesData.data);
        } else {
          setCountries([]);
        }
        setCategories(categoriesRes.data?.data || []);

        const jobData = jobRes.data || {};
        setInitialValues({
          title: jobData.title || '',
          title_fa: jobData.title_fa || '',
          city: jobData.city || '',
          city_fa: jobData.city_fa || '',
          country: jobData.country || '',
          company: jobData.company || '',
          apply_link: jobData.apply_link || '',
          responsibility: jobData.responsibility || '',
          document: jobData.document || '',
          type: jobData.type || '',
          subject: jobData.subject || '',
          salary: jobData.salary || '',
          deadline: jobData.deadline || '',
        });
      } catch (err) {
        console.error('Error fetching data:', err);
        MySwal.fire({
          title: 'خطا در دریافت اطلاعات',
          icon: 'error',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const validationSchema = yup.object({
    title: yup.string().required('وارد کردن عنوان الزامیست'),
    title_fa: yup.string().required('وارد کردن عنوان به فارسی الزامیست'),
    city: yup.string().required('وارد کردن شهر الزامیست'),
    city_fa: yup.string().required('وارد کردن شهر به فارسی الزامیست'),
    country: yup.string().required('وارد کردن کشور الزامیست'),
    company: yup.string().required('وارد کردن شرکت الزامیست'),
    apply_link: yup.string().required('وارد کردن لینک اپلای الزامیست'),
    responsibility: yup.string().required('وارد کردن مسئولیت الزامیست'),
    document: yup.string().required('وارد کردن مدارک الزامیست'),
    type: yup.string().required('وارد کردن دسته بندی الزامیست'),
    // subject: yup.string().required('وارد کردن موضوع الزامیست'),
    salary: yup.string().required('وارد کردن حقوق الزامیست'),
    deadline: yup.string().required('وارد کردن ددلاین الزامیست'),
  });

  const onSubmit = (values) => {
    axios
      .post('https://arianaapp.arianaapply.com/panel/edit-job-opportunity', {
        ...values,
        img: '',
        id: id,
      })
      .then((response) => {
        console.log(response);
        MySwal.fire({
          title: 'با موفقیت ثبت شد',
          icon: 'success',
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  };

  const formik = useFormik({
    initialValues: initialValues || {
      title: '',
      title_fa: '',
      city: '',
      city_fa: '',
      country: '',
      company: '',
      apply_link: '',
      responsibility: '',
      document: '',
      type: '',
      subject: '',
      salary: '',
      deadline: '',
    },
    onSubmit,
    validationSchema,
    enableReinitialize: true,
    validateOnMount: true,
  });

  if (loading || !initialValues) {
    return (
      <div className="index" style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <div className="index">
      <form onSubmit={formik.handleSubmit}>
        <h2>ویرایش موقعیت شغلی</h2>

        <InputCustom
          name="title"
          type="text"
          label="عنوان شغلی..."
          formikHandler={formik.getFieldProps('title')}
          formikErrors={formik.errors.title && formik.touched.title}
          formikErrorsName={formik.errors.title}
        />

        <InputCustom
          name="title_fa"
          type="text"
          label="عنوان شغلی به فارسی..."
          formikHandler={formik.getFieldProps('title_fa')}
          formikErrors={formik.errors.title_fa && formik.touched.title_fa}
          formikErrorsName={formik.errors.title_fa}
        />

        <InputCustom
          name="city"
          type="text"
          label="شهر..."
          formikHandler={formik.getFieldProps('city')}
          formikErrors={formik.errors.city && formik.touched.city}
          formikErrorsName={formik.errors.city}
        />

        <InputCustom
          name="city_fa"
          type="text"
          label="شهر به فارسی..."
          formikHandler={formik.getFieldProps('city_fa')}
          formikErrors={formik.errors.city_fa && formik.touched.city_fa}
          formikErrorsName={formik.errors.city_fa}
        />

        {/* <InputCustom
          name="subject"
          type="text"
          label="موضوع..."
          formikHandler={formik.getFieldProps('subject')}
          formikErrors={formik.errors.subject && formik.touched.subject}
          formikErrorsName={formik.errors.subject}
        /> */}

        <InputCustom
          name="salary"
          type="text"
          label="حقوق دریافتی..."
          formikHandler={formik.getFieldProps('salary')}
          formikErrors={formik.errors.salary && formik.touched.salary}
          formikErrorsName={formik.errors.salary}
        />

        {/* کشور */}
        <div className={styles.inputWrap}>
          <label className={styles.label}>کشور...</label>
          <select
            name="country"
            className={
              formik.errors.country && formik.touched.country
                ? styles.inputError
                : styles.input
            }
            {...formik.getFieldProps('country')}
          >
            <option value="">انتخاب کنید...</option>
            {countries.map((c) => (
              <option key={c._id} value={c.english_country}>
                {c.country}
              </option>
            ))}
          </select>
          {formik.errors.country && formik.touched.country && (
            <p className={styles.errorText}>{formik.errors.country}</p>
          )}
        </div>

        <InputCustom
          name="company"
          type="text"
          label="شرکت..."
          formikHandler={formik.getFieldProps('company')}
          formikErrors={formik.errors.company && formik.touched.company}
          formikErrorsName={formik.errors.company}
        />

        <InputCustom
          name="apply_link"
          type="text"
          label="لینک اپلای..."
          formikHandler={formik.getFieldProps('apply_link')}
          formikErrors={formik.errors.apply_link && formik.touched.apply_link}
          formikErrorsName={formik.errors.apply_link}
        />

        <InputCustom
          name="deadline"
          type="date"
          label="ددلاین.."
          formikHandler={formik.getFieldProps('deadline')}
          formikErrors={formik.errors.deadline && formik.touched.deadline}
          formikErrorsName={formik.errors.deadline}
        />

        {/* دسته‌بندی - داینامیک */}
        <div className={styles.inputWrap}>
          <label className={styles.label}>دسته‌بندی....</label>
          <select
            name="type"
            className={
              formik.errors.type && formik.touched.type
                ? styles.inputError
                : styles.input
            }
            {...formik.getFieldProps('type')}
          >
            <option value="">انتخاب کنید...</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat.category}>
                {cat.category_fa}
              </option>
            ))}
          </select>
          {formik.errors.type && formik.touched.type && (
            <p className={styles.errorText}>{formik.errors.type}</p>
          )}
        </div>
        <TextAreaCustom
          name="responsibility"
          type="text"
          label="مسئولیت‌ها.."
          formikHandler={formik.getFieldProps('responsibility')}
          formikErrors={
            formik.errors.responsibility && formik.touched.responsibility
          }
          formikErrorsName={formik.errors.responsibility}
        />

        <TextAreaCustom
          name="document"
          type="text"
          label="مدارک.."
          formikHandler={formik.getFieldProps('document')}
          formikErrors={formik.errors.document && formik.touched.document}
          formikErrorsName={formik.errors.document}
        />

        <div className="inputBox">
          <button
            type="submit"
            className={!formik.isValid ? 'btn-gray' : 'btn-success'}
            disabled={!formik.isValid}
          >
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditOpportunity;